import { render, staticRenderFns } from "./Push.vue?vue&type=template&id=35165048&scoped=true&"
import script from "./Push.vue?vue&type=script&lang=js&"
export * from "./Push.vue?vue&type=script&lang=js&"
import style0 from "./Push.vue?vue&type=style&index=0&id=35165048&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35165048",
  null
  
)

export default component.exports